// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2IOFh","legacyBtn":"MutateMid_legacyBtn__259wY"};